export default __webpack_public_path__ + "static/media/5.483eb00d.jpg";